import { createReducer, on } from '@ngrx/store';
import { InstalledApplicationsApiActions } from './device-installed-applications.actions';
import { adapter, initialState } from './device-installed-applications.state';

export const deviceInstalledApplicationsReducer = createReducer(
  initialState,
  on(InstalledApplicationsApiActions.installedApplicationsLoaded, (state, { installedApplications }) =>
    adapter.upsertMany(installedApplications, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceInstalledApplicationsIds = selectIds;

export const selectDeviceInstalledApplicationsEntities = selectEntities;

export const selectDeviceInstalledApplicationsStatuses = selectAll;
